import React from 'react';


const getElement = (target) => {
  if (typeof target === 'function') {
    return target();
  }

  if (target instanceof Element) {
    return target;
  }

  return target.current;
};

export const useClickOutside = ((...params) => {
  const target = (typeof params[1] === 'undefined' ? null : params[0])
  const callback = (params[1] ? params[1] : params[0])

  const internalRef = React.useRef(null);
  const internalCallbackRef = React.useRef(callback);

  React.useEffect(() => {
    internalCallbackRef.current = callback;
  }, [callback]);

  React.useEffect(() => {
    const handler = (event) => {
      if (Array.isArray(target)) {
        target.forEach((target) => {
          const element = getElement(target);

          if (element && !element.contains(event.target)) {
            internalCallbackRef.current(event);
          }
        });

        return;
      }

      const element = target ? getElement(target) : internalRef.current;

      if (element && !element.contains(event.target)) {
        internalCallbackRef.current(event);
      }
    };

    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, []);

  if (target) return;
  return internalRef;
});